module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/232.5c714779.png";